import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

import { useAuthBiogems } from '@cores/security/hooks/useAuthBiogems';
import { AppResource } from '@config/config';


const basePath = AppResource.basePath;
//console.log('basePath in useLayoutUtils:', basePath);

export const useLayoutUtils = () => {
 const authContext = useAuthBiogems();
 const { user } = authContext || {};
  const navigate = useNavigate();
  const isAuthenticated=!!user;

  const shouldShowMenuItem = useCallback((config) => {
     // If the item is flagged to hide on production, reject it immediately
    if (config.hideOnProd) return false;
    // Hide if requires auth and not authenticated
    if (config.requireAuth && !isAuthenticated) return false;
    // Hide if should be hidden when authenticated
    if (config.hideWhenAuth && isAuthenticated) return false;
    // Hide if requires a role and user doesn't have it
    if (config.requireRole && (!user || user.role !== config.requireRole)) return false;
    // Show everything else
    return true;
  }, [user]);

  // Refactored to use dispatch (useReducer)
  const handleMenuItemClick = (action, isNavigation, menuConfig, dispatch, dropdownItemConfig, parentKey) => {
    let menuItem;
    if (dropdownItemConfig) {
      menuItem = menuConfig[parentKey || 'settings'];
    } else {
      menuItem = menuConfig[action];
    }
    //console.log('handleMenuItemClick called:', { action, isNavigation, dropdownItemConfig, parentKey });
    //console.log('Resolved menuItem:', menuItem);
    if (!menuItem) {
      dispatch({ type: 'RESET' });
      return;
    }
    if (isNavigation) {
     // console.log('Navigating to:', `${basePath}${menuItem.path}`);
      navigate(`${basePath}${menuItem.path}`);
      dispatch({ type: 'NAVIGATE', menuItem });
    } else {
      dispatch({ type: 'NAVIGATE', menuItem });
      // dropdownTaskBar is managed by caller
    }
  };

  // Handles clicks on app task bar items
    const handleTaskBarItemClick = useCallback((action, taskBarItems) => {
        console.log('handleTaskBarItemClick action:', action, taskBarItems);
    const item = taskBarItems.find(i => i.action === action);
    if (item) {
        console.log('handleTaskBarItemClick called:', item);
        console.log('handleTaskBarItemClick item.action:', item.action);
      // Implement your task logic here
    } else {
      console.error(`Task bar item with action '${action}' not found.`);
    }
  }, []);

  // Handles clicks on dropdown task bar items
    const handleDropdownTaskBarItemClick = useCallback((action, dropdownTaskBarItems) => {
        console.log('handleDropdownTaskBarItemClick action:', action, dropdownTaskBarItems);
    const item = dropdownTaskBarItems.find(i => i.action === action);
    if (item) {
        console.log('handleDropdownTaskBarItemClick called:', item);
        
      // Implement your dropdown task logic here
    } else {
      console.error(`Dropdown task bar item with action '${action}' not found.`);
    }
  }, []);

  const handleMapTaskbarItemClick = (action, mapView) => {
    console.log('handleMapTaskbarItemClick called:', { action, mapView });
    if(action === 'zoom-out' && mapView){
      mapView.zoom = mapView.zoom - 1;
    }
    else if(action === 'zoom-in' && mapView){
      mapView.zoom = mapView.zoom + 1;
    }
  };


  return {
    shouldShowMenuItem,
    handleMenuItemClick,
    handleTaskBarItemClick,
    handleDropdownTaskBarItemClick,
    handleMapTaskbarItemClick
  };
};